<template>
    <ElementLayout :parent="parent" :element="element">
        <CurrencyBox v-model="element.value" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import CurrencyBox from '../../ui-elements/CurrencyBox'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ElementLayout,
        CurrencyBox,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// CurrencyControl.vue?1894fb79